export default __webpack_public_path__ + "static/media/book.56181ebc.png";